import React, { Component } from 'react';
import {connect} from 'react-redux'
//import {Link} from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import history from './history';

import { withTranslation } from 'react-i18next';
//import { switchCourse } from '../../actions';
import {COURSES} from './constants';



function forwardTo (location) {
  history.push(location)
}



class CourseDropdown extends Component {

    render(){
        const { t } = this.props;


        /*console.log("COURSE DROPDOWN")
        console.log(this.props.data.courseInfo)*/
        let userCourses = COURSES.filter(
            course =>
                this.props.data.courseInfo?
                Object.keys(this.props.data.courseInfo).includes(course.name)
                :
                false
        )
        //COURSES.filter(course=>course.state != 'in development'); // TODO: should be returned by API

        /*console.log('USERCOURSES')
        console.log(userCourses)*/

        if(!userCourses || !userCourses.length){
            // TODO: not pleasant UX, should keep cached userCourses in local storage
            return ''
            /*return <div className="btn-group course-dropdown-div">
                <button
                    className="btn btn-secondary course-dropdown"
                    //data-toggle="dropdown"
                    data-display="static"
                    aria-haspopup="false"
                    aria-expanded="false"
                    style={{border: 'none'}}
                    prop="{() => forwardTo('/courses')}"
                    onClick={() => forwardTo('/courses')}>
                    <img
                        style={{'width': '30px', 'height': '30px'}}
                        src="data:image/png;base64,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"/>
                    Add course
                </button>
            </div>*/
        }


        let currentCourse = userCourses.filter(course => course.name === this.props.data.currentCourse)[0]
        //console.log(currentCourse)

        return <div className="btn-group course-dropdown-div counter dropdown">
            <button
                type="button"
                className="btn btn-secondary dropdown-toggle course-dropdown"
                data-toggle="dropdown"
                data-display="static"
                aria-haspopup="true"
                aria-expanded="false"
                style={{border: 'none', "backgroundColor": "transparent"}}>
                <img
                    src={currentCourse? currentCourse.logo: ''}
                    style={{'width': '30px', 'height': '30px'}}
                    alt={''}/>
                <b style={{'fontWeight': 'normal'}} className="course-dropdown-current-course-text">&nbsp;{currentCourse? currentCourse.label: ''}</b>
            </button>
            <div className="dropdown-menu dropdown-menu-lg-right">
                {userCourses.map((course, id) =>
                        <button className="dropdown-item" type="button" key={id} onClick={() => switchCourse(this.props, course.name)}>
                            <img src={course.logo} style={{'width': '30px', 'height': '30px'}} alt={''}/>
                            &nbsp;{course.label}
                        </button>
                    )
                }
                <hr/>
                <button className="dropdown-item" type="button" onClick={() => history.push('/courses')}> + {t('Add more')}</button>
            </div>
        </div>
    }
}



function switchCourse(props, course){
    //props.dispatch(switchCourse(course))
    props.dispatch({
        type: 'SET_GENERIC',
        currentCourse: course
    })
    if(history.location.pathname !== '/learn'){
        forwardTo('/learn')
    }
}



// Which props do we want to inject, given the global state?
function select (state) {
  return {
    data: state
  }
}

// Wrap the component to inject dispatch and state into it
export default withRouter(
    connect(select)(
        withTranslation()(
            CourseDropdown
        )
    )
);
